import { API_BASE_URL } from './apiBase';

export type MessageTexts = {
  subject?: string;
  subjectEmpty?: string;
  subjectBooking?: string;
  subjectBookingEmpty?: string;
  body?: string;
  bodyBooking?: string;
  bodyThanks?: string;
  bodyFallback?: string;
  whatsapp?: string;
  whatsappBooking?: string;
};

type Catalogue = { version?: number; messages: Record<string, MessageTexts> };

let cached: Catalogue = { version: 1, messages: {} };
let loadPromise: Promise<Catalogue> | null = null;

export function fillMessageTemplate(template: string, vars: Record<string, string | undefined> = {}) {
  return String(template || '').replace(/\{([a-zA-Z][a-zA-Z0-9]*)\}/g, (match, name) => {
    if (!Object.prototype.hasOwnProperty.call(vars, name)) return match;
    const value = vars[name];
    if (value == null) return match;
    return String(value);
  });
}

export function getCachedMessageTemplates() {
  return cached;
}

export function setCachedMessageTemplates(catalogue: Catalogue | null | undefined) {
  cached = {
    version: 1,
    messages: catalogue && catalogue.messages && typeof catalogue.messages === 'object'
      ? catalogue.messages
      : {},
  };
}

export function messageText(id: string, field: string, fallback: string, vars: Record<string, string | undefined> = {}) {
  const row = cached.messages[id] || {};
  const template = (row as Record<string, string | undefined>)[field] || fallback;
  return fillMessageTemplate(template, vars);
}

export async function loadMessageTemplates(force = false) {
  if (!force && loadPromise) return loadPromise;
  loadPromise = (async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/studio/message-templates`, { credentials: 'include' });
      if (!response.ok) return cached;
      const body = await response.json();
      if (body && body.catalogue) setCachedMessageTemplates(body.catalogue);
      return cached;
    } catch (error) {
      return cached;
    }
  })();
  return loadPromise;
}
